<div class="loader" *ngIf="showLoader"></div>
<div class="app-page" *ngIf="!showLoader">
	<div class="container-fluid">
		<div class="page" fxLayout="row" fxLayoutAlign="center top" fxLayout.xs="column" fxFlexFill>
			<div fxFlex="100">
				<button
					class="page__back p-button-outlined"
					pButton
					(click)="back()"
					*ngIf="hasBackButton == 'true'"
				>
					{{ 'BACK' | translate }}
				</button>

				<div class="container page__title" color="" *ngIf="pageTitle">
					<h5
						[ngClass]="{
							alignSwitchAR: switchLangService.currentLang == 'ar',
							alignSwitchEN: switchLangService.currentLang == 'en'
						}"
					>
						{{ pageTitle }}
					</h5>
				</div>

				<mat-toolbar class="page__title--narrow" color="" *ngIf="pageTitleNarrow">
					<mat-toolbar-row>
						<span>{{ pageTitleNarrow }}</span>
					</mat-toolbar-row>
				</mat-toolbar>

				<ng-content></ng-content>
			</div>
		</div>
	</div>
</div>
